import type { SyntheticEvent } from 'react'

const cancelEvent = (event: Event | SyntheticEvent) => {
  event.preventDefault()
  event.stopPropagation()
}

export default cancelEvent
